import React from 'react';

export const StartIcon = () => {
  return (
    <div>
      <img src="/pictures/StartIcon.svg" alt="" />
    </div>
  );
};
